import { FC, useEffect, useState } from 'react';
const OuthPage: FC = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('https://easyidentity.ai/api/.well-known/openid-configuration');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>{JSON.stringify(data)}</>
    // <pre style={{ padding: '20px', backgroundColor: '#f5f5f5', overflow: 'auto' }}>
    // {JSON.stringify(data )}
    // </pre>
  );
};

export default OuthPage;
